import React, { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getOrderDetails } from '../../actions/orderActions'
import { errorHandle, ensureArray } from '../../utils/helper'
import { getListFood } from '../../selectors'
import paths from '../../routes/paths'

import OrderDetails from '../../components/order/OrderDetails'
import OrderDetailsSearch from '../../components/order/OrderDetailsSearch'
import DataNotFound from '../../components/common/DataNotFound'

const OrderDetailsContainer = ({ match }) => {
    const { orderID } = match.params
    const dispatch = useDispatch()
    const history = useHistory()
    const foods = useSelector(getListFood)

    const [orderDetails, setOrderDetails] = useState()

    const orderDetailsShow = useMemo(() => {
        if (!orderDetails || !foods) {
            return {}
        }
        return {
            ...orderDetails,
            foodData: ensureArray(orderDetails.foodData).map(el => ({
                ...el,
                imagePath:
                    foods.find(f => f.plu === Number(el.plu))?.imagePath || '',
            })),
        }
    }, [foods, orderDetails])

    const handleGetOrder = () => {
        dispatch(
            getOrderDetails({
                params: {
                    orderID,
                },
                onDone: ({ success, responseData }) => {
                    let data = null
                    if (success) {
                        data = responseData.data
                    } else {
                        setOrderDetails(null)
                        return errorHandle({
                            message: 'apiMessage.getOrderDetailsFailed',
                        })
                    }

                    setOrderDetails({
                        ...data,
                        totalMoney: data.totalMoney / 100,
                    })
                },
            })
        )
    }

    const handleSearch = code => {
        history.push(`${paths.orderDetails}/${code}`)
    }

    useEffect(() => {
        orderID && handleGetOrder()
    }, [orderID])

    if (!orderID) {
        return <OrderDetailsSearch handleSearch={handleSearch} />
    }

    if (orderDetails === null) {
        return <DataNotFound />
    }

    if (!orderDetails) {
        return null
    }

    return <OrderDetails orderDetails={orderDetailsShow} />
}

export default OrderDetailsContainer
